module.exports = __webpack_public_path__ + "assets/images/project/icons/icon_360_black.svg?v=7d523628";